// Header v2: mega menu, sombra ao rolar e selects de idioma/região da top bar.

var documentHandlers = [];

function addDocumentHandler(target, type, handler, options) {
  target.addEventListener(type, handler, options);
  documentHandlers.push(function() { target.removeEventListener(type, handler, options); });
}

// O Turbolinks troca o <body> a cada visita, mas os listeners em document/window
// ficam; removemos os da página anterior antes de registrar de novo.
function clearDocumentHandlers() {
  documentHandlers.forEach(function(remove) { remove(); });
  documentHandlers = [];
}

function setupMegaMenu(header) {
  var toggle = header.querySelector('[data-cda-menu-toggle]');
  var overlay = document.querySelector('[data-cda-menu-overlay]');
  if (!toggle) return;

  function isOpen() {
    return header.classList.contains('is-menu-open');
  }

  function setOpen(open) {
    header.classList.toggle('is-menu-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (overlay) overlay.hidden = !open;
  }

  setOpen(false);

  toggle.addEventListener('click', function() {
    setOpen(!isOpen());
  });

  if (overlay) {
    overlay.addEventListener('click', function() { setOpen(false); });
  }

  addDocumentHandler(document, 'keydown', function(event) {
    if (!isOpen() || (event.key !== 'Escape' && event.key !== 'Esc')) return;
    setOpen(false);
    toggle.focus();
  });

  // Não deixa o Turbolinks guardar a página no cache com o menu aberto.
  addDocumentHandler(document, 'turbolinks:before-cache', function() { setOpen(false); });
}

function setupScrollShadow(header) {
  var ticking = false;

  function update() {
    header.classList.toggle('is-scrolled', window.pageYOffset > 4);
    ticking = false;
  }

  update();
  addDocumentHandler(window, 'scroll', function() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
}

// Selects da top bar da Alemanha: o valor de cada opção é a URL de destino.
function setupRedirectSelects() {
  var selects = document.querySelectorAll('[data-cda-redirect-select]');
  Array.prototype.forEach.call(selects, function(select) {
    select.addEventListener('change', function() {
      if (select.value) window.location = select.value;
    });
  });
}

// Gaveta de navegação do mobile.
function setupDrawer() {
  var drawer = document.querySelector('[data-cda-drawer]');
  var openButton = document.querySelector('[data-cda-drawer-open]');
  var overlay = document.querySelector('.cda-drawer-overlay');
  if (!drawer || !openButton) return;

  var closeButton = drawer.querySelector('.cda-drawer__close');

  function isOpen() {
    return drawer.classList.contains('is-open');
  }

  function setOpen(open, restoreFocus) {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('cda-drawer-open', open);
    if (overlay) overlay.hidden = !open;

    if (open && closeButton) closeButton.focus();
    if (!open && restoreFocus) openButton.focus();
  }

  setOpen(false);

  openButton.addEventListener('click', function() { setOpen(true); });

  Array.prototype.forEach.call(document.querySelectorAll('[data-cda-drawer-close]'), function(el) {
    el.addEventListener('click', function() { setOpen(false, true); });
  });

  // Fecha ao seguir um link (o Turbolinks pode restaurar a página já com a gaveta aberta).
  drawer.addEventListener('click', function(event) {
    if (event.target.closest('a')) setOpen(false);
  });

  // Esc fecha; Tab fica preso dentro da gaveta enquanto ela está aberta.
  addDocumentHandler(document, 'keydown', function(event) {
    if (!isOpen()) return;

    if (event.key === 'Escape' || event.key === 'Esc') {
      setOpen(false, true);
      return;
    }

    if (event.key !== 'Tab') return;
    var focusables = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), summary'),
      function(el) { return el.offsetParent !== null; }
    );
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  addDocumentHandler(document, 'turbolinks:before-cache', function() { setOpen(false); });
}

// Lupa da barra mobile: volta ao topo e foca a busca (que rola junto com a página).
function setupMobileSearchFocus() {
  var button = document.querySelector('[data-cda-msearch-focus]');
  var input = document.getElementById('cda-msearch-input');
  if (!button || !input) return;

  button.addEventListener('click', function() {
    window.scrollTo(0, 0);
    input.focus({ preventScroll: true });
  });
}

document.addEventListener('turbolinks:load', function() {
  clearDocumentHandlers();
  setupRedirectSelects();
  setupDrawer();
  setupMobileSearchFocus();

  var mobileHeader = document.querySelector('[data-cda-mheader]');
  if (mobileHeader) setupScrollShadow(mobileHeader);

  var header = document.querySelector('[data-cda-header]');
  if (!header) return;

  setupMegaMenu(header);
  setupScrollShadow(header);
});
